import { render, staticRenderFns } from "./Qonunchilik.vue?vue&type=template&id=4acb1c9b&"
import script from "./Qonunchilik.vue?vue&type=script&lang=js&"
export * from "./Qonunchilik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports